<p-accordion *ngIf="accordionPanes && accordionPanes.length > 0" [value]="activeIndex" [multiple]="multiple">
      <ng-container  *ngFor="let obj of accordionPanes; let i = index">
            <p-accordion-panel [value]="i">
                <p-accordion-header *ngIf="obj.headerData">
                    <ng-container *ngTemplateOutlet="headerTemplate; context:{data:obj.headerData}"></ng-container>
                    
                    <!-- <ng-template #toggleicon let-active="active">
                        @if (active) {
                            <i class="pi pi-minus"></i>
                        } @else {
                            <i class="pi pi-plus"></i>
                            <ng-container *ngTemplateOutlet="rowContent;context:{row:rowData}"></ng-container>
                        }  
                    </ng-template>
                    <span class="flex items-center gap-2 w-full">
                        <p-avatar image="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png" shape="circle" />
                        <span class="font-bold whitespace-nowrap">Amy Elsner</span>
                        <p-badge value="3" class="ml-auto mr-2" />
                    </span> -->
                </p-accordion-header>
                <p-accordion-content *ngIf="obj.contentData">
                    <ng-container *ngTemplateOutlet="contentTemplate; context:{data:obj.contentData}"></ng-container>
                    <!-- <p class="m-0">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                        consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est
                        laborum.
                    </p> -->
                </p-accordion-content>
            </p-accordion-panel>
      </ng-container>

</p-accordion>